<div class="speciality-pricelist-container">
    <div class="title-container">
        <div class="title">
            <div class="pricelist">
                <h2>RENDELÉSI IDŐK</h2>
            </div>
        </div>
    </div>
    <div class="speciality">
        <div class="icons"></div>
        <div class="spec">
            @for (speciality of specialities; track speciality; let i = $index) {
                <div class="speciality-element">
                    <div class="name-container">
                        <div class="name" (click)="chooseOneSpeciality(speciality)">
                            <p>
                                <b [ngStyle]="{ 'font-size': '18px' }">{{ speciality.name! | uppercase }}</b>
                            </p>
                        </div>
                        @if (speciality.hasSpecialityChosen && speciality.isVisible) {
                            <div class="exam">
                                @for (doctorspeciality of speciality.doctorSpecialityList; track doctorspeciality; let i = $index) {
                                    <div class="examination-container">
                                        <div routerLink="/doctor/{{ doctorspeciality.doctor?.routerLink }}" class="examination">
                                            <div class="examination-name" [ngStyle]="{ 'flex-direction': 'column' }">
                                                <div class="image">
                                                    <img [ngStyle]="{ width: '100px' }" [src]="doctorspeciality.doctor?.thumbnailUrl" />
                                                </div>
                                            </div>
                                            <div class="consulting-hour-container">
                                                @if (doctorspeciality.doctor?.name !== 'labor') {
                                                    <b>{{ doctorspeciality.doctor?.name }}</b>
                                                }
                                                <b>Rendelési idő:</b>
                                                <div class="consult">
                                                    @for (
                                                        consultingHour of doctorspeciality.doctor?.doctorConsultingHourList;
                                                        track consultingHour
                                                    ) {
                                                        <div>
                                                            <div class="consulting">
                                                                <span>{{ consultingHour.day }}:</span>
                                                                @if (consultingHour.startTime !== null && consultingHour.endTime !== null) {
                                                                    <span>
                                                                        {{ consultingHour.startTime }} - {{ consultingHour.endTime }}
                                                                    </span>
                                                                }
                                                                @if (consultingHour.startTime === null && consultingHour.endTime === null) {
                                                                    <span> változó</span>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="consulting-hour-container">
                      <div *ngIf="doctorspeciality.doctor?.name !== 'Labor'" class="image">
                        <img [ngStyle]="{ width: '100px' }" [src]="doctorspeciality.doctor?.image" />
                      </div>
                      <span>{{ doctorspeciality.doctor?.name }}</span>
                      <h3>Rendelési idő:</h3>
                      <div class="consult">
                        <div
                          *ngFor="let consultingHour of doctorspeciality.doctor?.doctorConsultingHourList!"
                          class="consulting-hours"
                          >
                          <div class="consulting-hour">
                            <span>{{ consultingHour.day }}</span>
                            <span *ngIf="consultingHour.startTime !== null && consultingHour.endTime !== null">
                              {{ consultingHour.startTime }} - {{ consultingHour.endTime }}
                            </span>
                            <span *ngIf="consultingHour.startTime === null && consultingHour.endTime === null"
                              >változó</span
                              >
                            </div>
                          </div>
                        </div>
                      </div> -->
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>
